import { render, staticRenderFns } from "./CourseSeparator.vue?vue&type=template&id=08b46e87&scoped=true&"
import script from "./CourseSeparator.vue?vue&type=script&lang=js&"
export * from "./CourseSeparator.vue?vue&type=script&lang=js&"
import style0 from "./CourseSeparator.vue?vue&type=style&index=0&id=08b46e87&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b46e87",
  null
  
)

export default component.exports